// Moves one step between sections, or within a section.
// toIndex is the index in the destination list as it was when the drop happened,
// which matches today's reorderItems: remove the step, then insert at that index.
// Dropping a step on itself (same section, same index) changes nothing.
// The returned sections are new objects; the moved item object is the same reference.
export function moveStep(sections, fromSectionId, itemId, toSectionId, toIndex) {
  const from = sections.find((s) => s.id === fromSectionId);
  const to = sections.find((s) => s.id === toSectionId);
  if (!from || !to) return sections;
  const fromIndex = from.items.findIndex((item) => item.id === itemId);
  if (fromIndex < 0) return sections;
  if (fromSectionId === toSectionId && fromIndex === toIndex) return sections;

  const item = from.items[fromIndex];
  return sections.map((section) => {
    if (section.id !== fromSectionId && section.id !== toSectionId) return section;
    const items = section.id === fromSectionId
      ? section.items.filter((entry) => entry.id !== itemId)
      : [...section.items];
    if (section.id === toSectionId) {
      const insertAt = Math.max(0, Math.min(toIndex, items.length));
      items.splice(insertAt, 0, item);
    }
    return { ...section, items };
  });
}
